import '../../../common/dashboard/filters/unapplied/unapplied_filter_with_checkbox.js.coffee'
Namespace 'CustomerVisualMode.Filters.Unapplied'

class CustomerVisualMode.Filters.Unapplied.UnappliedStatusFilterView extends Common.Dashboard.Filters.UnappliedFilterWithCheckbox

  _displayTitle: ->
    I18n.t 'customer_visual_mode.filters.status'

  _getSelectedValues: ->
    input.value for input in @$el.find('input') when input.checked

  _translateOptionName: (name) ->
    I18n.t("common.ticket.status.#{name}")
